<template>
  <dialog-base
    :visible.sync="visible"
    title="Hướng dẫn thao tác khoản thu gốc"
    size="lg"
    cancel-text="Đóng"
    confirm-text="Đã hiểu"
    :use-panel="false"
    :append-to-body="true"
    top="6vh"
    @confirm="handleClose"
    @cancel="handleClose"
  >
    <div class="prg-guide">
      <div class="prg-section">
        <p class="prg-title">1) Thông tin chung</p>
        <ul>
          <li>Nhập <strong>Tên khoản thu</strong>, chọn <strong>Loại khoản</strong> và <strong>Đơn vị tính</strong>.</li>
          <li>Dùng <strong>Mô tả</strong> để ghi chú ngắn giúp dễ quản lý và tìm kiếm.</li>
        </ul>
      </div>

      <div class="prg-section">
        <p class="prg-title">2) Tài chính</p>
        <ul>
          <li>Nhập <strong>Đơn giá</strong> và <strong>Số lượng</strong> để hệ thống tính thành tiền tham khảo.</li>
          <li>Nếu bật <strong>Giảm giá</strong>, chọn kiểu giảm theo <strong>%</strong> hoặc theo <strong>số tiền</strong>.</li>
          <li>Phần <strong>Thành tiền</strong> và <strong>Số tiền bằng chữ</strong> là giá trị preview trên giao diện.</li>
        </ul>
        <p class="prg-example">Ví dụ: Đơn giá 2.000.000, số lượng 1, giảm 10% - thành tiền tham khảo còn 1.800.000.</p>
      </div>

      <div class="prg-section">
        <p class="prg-title">3) Thời gian áp dụng</p>
        <ul>
          <li><strong>Theo tháng</strong>: chọn tháng áp dụng và cấu hình chu kỳ cả tháng hoặc theo ngày.</li>
          <li><strong>Theo khoảng ngày</strong>: chọn ngày bắt đầu và ngày kết thúc.</li>
<!--          <li><strong>Số đơn vị</strong>: nhập giới hạn số lượng đơn vị nếu có yêu cầu nghiệp vụ.</li>-->
        </ul>
      </div>

      <div class="prg-section">
        <p class="prg-title">4) Cấu hình điểm danh</p>
        <ul>
          <li>Bật <strong>Áp dụng điểm danh</strong> khi cần tính phí/hoàn phí theo dữ liệu điểm danh.</li>
          <li>Chọn <strong>Phương pháp tính</strong>, <strong>Loại điểm danh</strong> và <strong>Chi tiết</strong> phù hợp.</li>
          <li>Nếu chọn <strong>Đón muộn (LATE)</strong>, cần cấu hình giờ đón về và các block thời gian tính tiền.</li>
        </ul>
      </div>

      <div class="prg-note">Mẹo: Bạn vẫn có thể rê chuột vào từng biểu tượng dấu hỏi cạnh để xem giải thích nhanh tại chỗ.</div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";

export default {
  name: "PrincipalRevenueGuideDialog",
  components: { DialogBase },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.prg-guide {
  max-height: 72vh;
  overflow: auto;
  padding-right: 4px;
}

.prg-section + .prg-section {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
}

.prg-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

ul {
  margin: 0 0 4px 16px;
  padding: 0;
  color: #334155;
  line-height: 1.5;
}

.prg-example {
  margin: 0;
  color: #0f766e;
  font-size: 12px;
  font-style: italic;
}

.prg-note {
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
}
</style>

